import * as React from 'react'
import { View, Text, TouchableOpacity } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'

import useI18n from '@i18n/useI18n'
import useBreakpoint from '@utils/useBreakpoints'

import theme from '@theme/Theme'

import { callPhoneNumber } from '@utils/userUtils'

interface Props {
  technician?: UserResponse
  contact?: UserResponse
  manifestation?: ManifestationResponse
}

const IncidentManifestationMobile = ({ technician, contact, manifestation }: Props) => {
  const i18n = useI18n()

  const [open, setOpen] = React.useState(false)

  return (
    <Container>
      {!!technician && (
        <TechnicianContainer>
          <Tab>
            <TabLabel>
              {i18n.t('screens.incidentDetail.technician', {
                firstName: technician.prenom,
                lastName: technician.nom,
              })}
            </TabLabel>
          </Tab>
        </TechnicianContainer>
      )}
      <ManifestationContainer>
        <ManifestationName>
          {!!manifestation ? manifestation.libelle : i18n.t('screens.incidentDetail.noManifestation')}
        </ManifestationName>
        {!!contact && (
          <>
            <ContactButton activeOpacity={0.9} onPress={() => setOpen(!open)}>
              <ContactLabel>{i18n.t('screens.incidentDetail.creator')}</ContactLabel>
              <Icon name={open ? 'arrow-up' : 'arrow-down'} color={theme.colors.primary} size={24} />
            </ContactButton>
            {open && (
              <ContactName
                activeOpacity={0.9}
                disabled={!contact.numeroTelephonePortable}
                onPress={() => callPhoneNumber(contact.numeroTelephonePortable)}>
                <View>
                  <ContactLabel>
                    {contact.prenom} {contact.nom}
                  </ContactLabel>
                  {!!contact.email && <ContactLabel>{contact.email}</ContactLabel>}
                </View>
                {!!contact.numeroTelephonePortable && <Icon name="phone" color={theme.colors.primary} size={24} />}
              </ContactName>
            )}
          </>
        )}
      </ManifestationContainer>
    </Container>
  )
}

const IncidentManifestationWeb = ({ manifestation }: Props) => {
  const i18n = useI18n()

  return (
    <>
      <Subtitle>{i18n.t('screens.incidentDetail.exhibitor')}</Subtitle>
      <Info>{!!manifestation ? manifestation.libelle : i18n.t('screens.incidentDetail.noManifestation')}</Info>
      {!!manifestation && (
        <>
          <Info>{manifestation.nomOrganisateur}</Info>
          {/*//TODO: pas de champs phone dans manifestation => getUser*/}
          {/*{incident.manifestation.phone && <Info>{incident.manifestation.phone}</Info>}*/}
        </>
      )}
    </>
  )
}

const IncidentManifestation = (props: Props) => {
  const [, bp] = useBreakpoint()
  const isPhone = bp === 'phone'

  return isPhone ? <IncidentManifestationMobile {...props} /> : <IncidentManifestationWeb {...props} />
}

export default IncidentManifestation

const Container = styled(View)`
  ${(props) => props.theme.breakpoint === 'phone' && 'margin-top: 18px;'};
`

const TechnicianContainer = styled(View)`
  flex-direction: row;
`

const ManifestationContainer = styled(View)`
  ${(props) =>
    props.theme.breakpoint === 'phone' &&
    `
      background-color: ${props.theme.colors.background};
      border-radius: 8px;
    `};
`

const Tab = styled(View)`
  background-color: ${(props) => props.theme.colors.secondaryActive};
  padding: 4px 8px 20px;
  margin-bottom: -16px;
  flex: 1;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`

const TabLabel = styled(Text)`
  ${(props) => props.theme.fonts.Caption1};
  text-align: center;
`
const ManifestationName = styled(Text)`
  text-align: center;
  ${(props) => props.theme.fonts.Headline};
  padding: 16px;
`
const ContactButton = styled(TouchableOpacity)`
  padding: 8px 16px;
  flex-direction: row;
`
const ContactLabel = styled(Text)`
  ${(props) => props.theme.fonts.Body};
  flex: 1;
`
const ContactName = styled(TouchableOpacity)`
  padding: 8px 16px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-top-width: 1px;
  border-color: ${(props) => props.theme.colors.disable};
`
const Info = styled(Text)`
  margin-bottom: 8px;
  ${(props) => props.theme.fonts.Footnote}
  font-size: 16px;
  color: ${(props) => props.theme.colors.secondaryText};
`
const Subtitle = styled(Text)`
  ${(props) => props.theme.fonts.Callout};
  margin-bottom: 8px;
`
